import { motion } from 'framer-motion';

const TABS = [
  { id: 'all', label: 'All' },
  { id: 'albums', label: 'Albums' },
  { id: 'uploads', label: 'My Uploads' },
  { id: 'shared', label: 'Shared With Me' },
];

const MemoryTabs = ({ active, onChange, isOwnProfile }) => {
  const visible = isOwnProfile ? TABS : TABS.filter((t) => t.id === 'all' || t.id === 'albums');

  return (
    <div className="mb-4 flex gap-2 overflow-x-auto pb-0.5 scrollbar-hide">
      {visible.map((tab) => {
        const selected = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`relative shrink-0 rounded-full px-4 py-2 text-xs font-semibold transition-all sm:text-sm ${
              selected
                ? 'bg-surface-900 text-white shadow-sm dark:bg-white dark:text-surface-900'
                : 'bg-surface-100 text-surface-600 hover:bg-surface-200 dark:bg-[#1B2435] dark:text-[#B5BDD1] dark:hover:bg-[#243044]'
            }`}
          >
            {selected && (
              <motion.span
                layoutId="memory-pill"
                className="absolute inset-0 -z-10 rounded-full"
                transition={{ type: 'spring', stiffness: 400, damping: 32 }}
              />
            )}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default MemoryTabs;
